import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "stillroom.installHint.dismissed";

function isStandalone() {
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    (typeof navigator !== "undefined" && navigator.standalone === true)
  );
}

function detectPlatform() {
  const ua = navigator.userAgent || "";
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/.test(ua);
  return { isIOS, isAndroid };
}

export default function InstallHint() {
  const [visible, setVisible] = useState(false);
  const [platform, setPlatform] = useState({ isIOS: false, isAndroid: false });
  const location = useLocation();
  const allowedRoutes = ["/", "/history"];
  const onAllowedRoute = allowedRoutes.includes(location.pathname);

  useEffect(() => {
    if (isStandalone()) return;
    if (localStorage.getItem(KEY)) return;
    setPlatform(detectPlatform());
    const t = setTimeout(() => setVisible(true), 3500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  if (!visible || !onAllowedRoute) return null;

  return (
    <div
      data-testid="install-hint"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[min(92%,26rem)] z-50 bg-still-surface/95 backdrop-blur-xl border border-still-border rounded-2xl px-4 py-3 flex items-start gap-3 shadow-[0_8px_32px_rgba(0,0,0,0.4)]"
    >
      <div className="flex-1">
        <div className="text-still-fg text-sm font-medium">
          Add Stillroom to your home screen
        </div>
        <div className="text-still-muted text-xs mt-1 leading-relaxed">
          {platform.isIOS
            ? "Tap Share, then Add to Home Screen."
            : platform.isAndroid
            ? "Tap the menu, then Install app."
            : "Use your browser menu → Install app."}
        </div>
      </div>
      <button
        data-testid="install-hint-dismiss"
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-still-muted hover:text-still-fg transition-colors"
      >
        <X size={16} />
      </button>
    </div>
  );
}
